import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";
import {Link, useHistory} from 'react-router-dom'

const Register = () => {
  const hist = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);


  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  const register = async (formData) => {
    if (!validateInput()) {
      return;
    }
    try {
      setIsLoading(true);
      const resp = await axios.post(`${config.endpoint}/auth/register`, { username, password });
      setIsLoading(false);
      enqueueSnackbar("Registered Successfully", { variant: 'success' });
      hist.push("/login");
    } catch (err) {
      console.log(err.response)
      setIsLoading(false);
      if (err.response && err.response.status === 400) {
        enqueueSnackbar("Username is already taken", { variant: 'error' });
      } else {
        enqueueSnackbar("Something went wrong!", { variant: 'error' });
      }
    }
  };

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const validateInput = () => {
    if (username && password && confirmPassword) {
      if (username.length >= 6) {
        if (password.length >= 6) {
          if (confirmPassword === password) {
            return true;
          }
          enqueueSnackbar("Passwords do not match!", { variant: 'warning' })
          return false;
        }
        enqueueSnackbar("Password must be atleast 6 characters!", { variant: 'warning' })
        return false;
      }
      enqueueSnackbar("Username must be atleast 6 characters!", { variant: 'warning' })
      return false;
    }
    enqueueSnackbar("Please fill all the required fields!", { variant: 'warning' })
    return false;
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            fullWidth
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            fullWidth
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          {isLoading ? <Box className="spinner"><CircularProgress /></Box> :
            <Button className="button" variant="contained" onClick={register}>
              Register Now
            </Button>
          }
          <p className="secondary-action">
            Already have an account?{" "}
            {/* <Link to="/login" className="link">Login here</Link> */}
            <Link className="link" to="/Login">login here</Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
